import component from './en-US/component.json';
import menu from './en-US/menu.json';
import pages from './en-US/pages.json';
import settings from './en-US/settings.json';
import error from './en-US/error.json';
import role from './en-US/role.json';

export default {
  'navBar.lang': 'Languages',
  'layout.user.link.help': 'Help',
  'layout.user.link.privacy': 'Privacy',
  'layout.user.link.terms': 'Terms',
  'app.copyright.company': 'T-connect Co., Ltd.',
  'app.copyright.produced': 'Produced by Ant Financial Experience Department',
  'app.preview.down.block': 'Download this page to your local project',
  'app.welcome.link.fetch-blocks': 'Get all block',
  'app.welcome.link.block-list': 'Quickly build standard, pages based on `block` development',
  ...menu,
  ...settings,
  ...component,
  ...pages,
  ...error,
  ...role,
};
